import React from 'react';
export const Logo = ({
  size = 'normal'
}) => {
  const sizeClasses = {
    small: 'h-8',
    normal: 'h-10',
    large: 'h-16'
  };
  return <div className="flex items-center" data-id="element-81">
      <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wFmvyZtS6bX3WmqxpQj4ZE/1000009561.png" alt="Scion Digital Preservation Logo" className={`${sizeClasses[size]} w-auto`} data-id="element-82" />
    </div>;
};